<!-- Atlan WIP  -->
<!-- This component has been adjusted to render astral fields and may need further adjustments to work in other parts of the application -->

@if (title) {
  <h4 class="postal-address__title astral-heading-with-help">
    <span>{{ title | translate }}</span>
    @if (helpText) {
      <astral-popover [helpText]="helpText" />
    }
  </h4>
}
@if (group) {
  <astral-layout-group [columns]="1">
    @if (showName) {
      <astral-input [control]="group.controls['name']" />
    }
    <astral-input [control]="group.controls['additionalName']" />
    <app-address [group]="group" [model]="model" [mandatory]="mandatory" [title]="null" [countryColumnSpan]="countryColumnSpan"></app-address>
  </astral-layout-group>
}
